(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener('DOMContentLoaded', () => {
      const card = document.getElementById(url.hash.slice(1));
      if (card) card.scrollIntoView({ behavior: 'instant' });
    }, { once: true });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-hoodies-mobile-word-fix"] && !Shopify.designMode) return;
  try {
    
(function () {
  function applyFlynovaBrand() {
    var logo = document.querySelector('[data-mhh] .mhh-logo');
    if (!logo) return;

    logo.innerHTML = 'FLYNOVA<span>ESSENTIALS</span>';
    logo.setAttribute('aria-label', 'Flynova Essentials');
  }

  applyFlynovaBrand();
  document.addEventListener('shopify:section:load', applyFlynovaBrand);
})();

  } catch(e) { console.error(e); }
})();
})();
